import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SocialsComponent } from '../socials/socials.component';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SocialsComponent],
  template: `
    <footer>
      <div class="h-1 bg-black"></div>
      <div class="bg-brand-cream text-black flex flex-col items-center gap-4 py-12 px-8">
        <p class="font-pirata text-3xl">HIGH HEAT</p>
        <p class="text-center">straight up rock 'n' roll from knoxville tennessee</p>
        <app-socials />
      </div>
    </footer>
  `,
})
export class FooterComponent {}
